module.exports = __webpack_public_path__ + "static/media/PSC.158d6066.jpg";